import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=14a351dc&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a351dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14a351dc')) {
      api.createRecord('14a351dc', component.options)
    } else {
      api.reload('14a351dc', component.options)
    }
    module.hot.accept("./_id.vue?vue&type=template&id=14a351dc&scoped=true&", function () {
      api.rerender('14a351dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/offers/_id.vue"
export default component.exports